import { render, staticRenderFns } from "./BloqueioSuporte.vue?vue&type=template&id=99f510fe&scoped=true"
import script from "./BloqueioSuporte.vue?vue&type=script&lang=js"
export * from "./BloqueioSuporte.vue?vue&type=script&lang=js"
import style0 from "./BloqueioSuporte.vue?vue&type=style&index=0&id=99f510fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f510fe",
  null
  
)

export default component.exports